/**
 * Browser Polyfills
 * Polyfills for features not available in browsers from the last 5 years.
 * This file is loaded on the client side in app/layout.tsx
 *
 * We use custom implementations from shared-polyfills.ts to minimize bundle size.
 * No external dependencies needed for these simple polyfills.
 */

import {
  polyfillArrayFindLast,
  polyfillArrayFindLastIndex,
  polyfillAbortSignalAny,
  polyfillStructuredClone,
  suppressNullDetailCompositionEnd,
} from './shared-polyfills';

// Apply polyfills for older browsers
polyfillArrayFindLast();
polyfillArrayFindLastIndex();
polyfillAbortSignalAny();
polyfillStructuredClone();
suppressNullDetailCompositionEnd();
